export default "__VITE_ASSET__IwNqNq1q__"